













































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import moment from "moment";
import BulkEnrollmentUploadRules from "@/employer/components/profile/BulkEnrollmentUploadRules.vue";
import { useThemeStore } from "@/shared/store/theme";


@Component({
  components: {
    BulkEnrollmentUploadRules
  }
})
export default class BulkEnrollmentUploadModal extends Vue {
  themeStore = useThemeStore();

  get fileSubmitCutoffHour () {
    const now = moment();
    let utc17 = moment.utc([now.year(), now.month(), now.day(), 17]);

    if (now.isAfter(utc17)) {
      // go to tomorrow
      utc17 = utc17.add(1, "days");
    }

    return utc17.isDST() ? "1" : "12";
  }
}
